export enum EmailTab {
  Customise,
  Settings,
  Attachments,
  Preview,
}
